export interface MessageState {
  messageCode: string;
  message: string;
  errorMessage: string;
  errorCode: string;
  isError: boolean;
  isMessage: boolean;
  isHistoryBack: boolean;
  isRefresh: boolean;
}

export const initMessage = {
  messageCode: '',
  message: '',
  errorMessage: '',
  errorCode: '',
  isError: false,
  isMessage: false,
  isHistoryBack: false,
  isRefresh: false
};
